import { useState, useRef, useEffect } from 'react'

export const AgencySelect = ({ options = [], disabledOptions = [], value = null, onChange, fallback }) => {

  const [ selected, setSelected ] = useState(value)
  const [ search, setSearch ] = useState('')
  const [ showDropDown, setShowDropDown ] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handleFocusOut = (e) => setShowDropDown( prev => {
      if (
        !prev ||
        e.target.closest('.tgbl-accrediting-agency-select') === ref.current ||
        e.target.closest('.tgbl-accrediting-agency-select__header__cancel')
      ) return prev

      return false
    })
    document.addEventListener('click', handleFocusOut)

    return () => { document.removeEventListener('click', handleFocusOut) }
  }, [])

  useEffect(() => { if ( onChange ) onChange( selected )}, [selected])

  return (
    <div className="tgbl-accrediting-agency-select" ref={ref}>

      <div className="tgbl-accrediting-agency-select__header">
        { showDropDown || selected === null
          ? <>
            <svg
              width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"
              className="tgbl-accrediting-agency-select__header__search"
            >
              <path d="M1 12L5 8.5" stroke="#1E1E1E" strokeWidth="1.5"/>
              <circle cx="8.5" cy="5.5" r="4.75" stroke="#1E1E1E" strokeWidth="1.5"/>
            </svg>
            <input
              type="text"
              className="tgbl-accrediting-agency-select__header__input"
              placeholder="Search for your board"
              onFocus={() => setShowDropDown(true)}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </>
          : <>
            <span className="tgbl-accrediting-agency-select__header__selected-value">{selected.label}</span>
            <svg
              width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
              className="tgbl-accrediting-agency-select__header__cancel"
              onClick={() => {
                setSelected(null)
                setShowDropDown(true)
              }}
            >
              <path fillRule="evenodd" clipRule="evenodd" d="M8.00094 8.86732L1.53898 15.5216L0.462891 14.4766L6.95549 7.79076L0.86745 1.52156L1.94354 0.476563L8.00094 6.71421L14.0583 0.476562L15.1344 1.52156L9.04638 7.79076L15.539 14.4766L14.4629 15.5216L8.00094 8.86732Z" fill="#1E1E1E"/>
            </svg>
          </>
        }
      </div>

      { showDropDown && <div className="tgbl-accrediting-agency-select__dropdown">
        <div className="tgbl-accrediting-agency-select__dropdown__option-list">
          { options.filter(i => i.label.toLowerCase().includes(search.toLowerCase())).map((option, index) => <div
            key={`${index}-${option.value}`}
            className="tgbl-accrediting-agency-select__dropdown__option-list__option"
          >
            <span className="tgbl-accrediting-agency-select__dropdown__option-list__option__label">{option.label}</span>
            <button
              className="tgbl-button tgbl-button--theme-primary tgbl-accrediting-agency-select__dropdown__option-list__option__choose tgbl-button--size-sm"
              type="button"
              onClick={() => {
                setSearch('') // or set it to selected option
                setSelected(option)
                setShowDropDown(false)
              }}
              disabled={disabledOptions.includes(option.value)}
            >Select this board</button>
          </div> ) }
        </div>
        <div className="tgbl-accrediting-agency-select__dropdown__actions">
          <span>Utilizing our national approval and your board isn't listed?</span>
          <button className="tgbl-button tgbl-button--theme-secondary tgbl-button--size-sm" type="button" onClick={fallback}>Add your board</button>
        </div>
      </div> }
    </div>
  )
}
